export function getUserId() {
  let accountDto = localStorage.getItem('ACCOUNT_DTO')
  if (accountDto) {
    accountDto = JSON.parse(accountDto)
  }
  return (accountDto && accountDto.id)? accountDto.id : ''
}

export function getNickName() {
  let accountDto = localStorage.getItem('ACCOUNT_DTO')
  if (accountDto) {
    accountDto = JSON.parse(accountDto)
  }
  return (accountDto && accountDto.nickName) ? accountDto.nickName : ''
}


export function getRoletype() {
  let accountDto = localStorage.getItem('ACCOUNT_DTO')
  if (accountDto) {
    accountDto = JSON.parse(accountDto)
  }
  return (accountDto && accountDto.roleType) ? accountDto.roleType : ''
}
